import React, { useState } from "react";

/* Collapsed-by-default section: a slim header bar, click to expand/collapse. */
export default function Collapsed({ title, children }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ margin: "10px 0" }}>
      <button onClick={() => setOpen(o => !o)}
        style={{
          width: "100%", textAlign: "left", background: "var(--panel)", color: "var(--text-muted)",
          border: "1px solid var(--border)", borderRadius: 8, padding: "8px 14px",
          fontSize: 12, fontWeight: 600, cursor: "pointer",
        }}>
        {open ? "▾" : "▸"} {title}
      </button>
      {open && <div style={{ marginTop: 8 }}>{children}</div>}
    </div>
  );
}
